import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementReservationEdit } from "@/components/features/management/reservation/item/edit";

import { useConfirmParams } from "./hooks";

export const ManagementReservationEditPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, reservationID } = result;

	return (
		<PageMeta
			title="予約の編集"
			url={generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.EDIT, { hotelID, reservationID })}
		>
			<ManagementReservationEdit hotelID={hotelID} reservationID={reservationID} />
		</PageMeta>
	);
};
